module.exports = (__webpack_require__(14))(2);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js from dll-reference vendor_library
// module id = 32
// module chunks = 0